<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep
      :type="prop.type"
      :currentStep="0"
      :countDown="prop.countDown"
      :eligibility="eligibility"
    >
    </PogressBarStep>
    <div :class="[deviceType, 'description']">
      <div
        :class="{
          desc1:
            prop.type == 'EP_CC' || prop.productBundlingExpiredtype == 'EP_CC',
        }"
      >
        <p :class="[deviceType, 'desc']" style="font-size: 16px">
          {{ t("ccOnBoarding.cardListing.recommendation") }}
        </p>
      </div>
      <div>
        <div
          v-if="
            (prop.type == 'EP_CC' ||
              prop.productBundlingExpiredtype == 'EP_CC') &&
            prop.multiChannel.mc
          "
          :class="[deviceType, 'merchant_code']"
        >
          {{ t("ccOnBoarding.merchantCode") }} {{ prop.multiChannel.mc }}
        </div>
      </div>
    </div>
    <div :class="[deviceType, 'cards']">
      <div
        class="singleCard"
        v-for="card in cards"
        :class="{ 'card-selected': card.selected }"
        @click="toggleSelected(card)"
      >
        <div class="cardImgBox">
          <img class="cardImage" :src="'data:image/png;base64,' + card.image" />
        </div>
        <p class="cardName">{{ card.cardName }}</p>
        <!-- <div style="margin-bottom: 20px"> -->
        <div class="infoBox">
          <div
            class="cardInfo"
            v-for="(info, index) in getFilteredInfo(card.cardInfo)"
            :key="index"
          >
            <img
              style="width: 6.9px; height: 13px"
              class="path-65"
              src="../../../assets/icons/tick.svg"
            />
            <p>{{ info }}</p>
          </div>
        </div>

        <!-- <div class="cardSelected-div">
          <p class="cardSelected">
            {{ t("ccOnBoarding.cardListing.selected") }}
          </p>
        </div> -->

        <!-- <button :class="[deviceType, 'findOut-button']">
          {{ t("ccOnBoarding.cardListing.findOutMore") }}
          <img
            style="width: 23px; height: 30px"
            class="path-65"
            src="../../../assets/icons/Arrow_right.svg"
          />
        </button> -->
      </div>
    </div>
    <div :class="[deviceType, 'buttoncontainer']">
      <button
        v-if="
          prop.type == 'BIO' || prop.type == 'CR_SL' || prop.type == 'FINPLUS'
        "
        :class="[deviceType, 'left-button']"
        type="button"
        @click="handleBack"
      >
        {{ t("ccOnBoarding.back") }}
      </button>
      <div
        v-else
        :class="[deviceType, 'left-button']"
        style="visibility: hidden"
      ></div>
      <button
        :class="[deviceType, 'right-button']"
        :disabled="isBtnDisabled"
        @click="jump()"
      >
        {{ t("ccOnBoarding.next") }}
      </button>
    </div>
  </div>
  <div v-if="overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  onBeforeMount,
  type PropType,
  watch,
} from "vue";
import Headers from "./components/Headers.vue";
import i18n from "@/plugin/i18n";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { deviceDetect } from "mobile-device-detect";
import PogressBarStep from "./components/ProgressBarStep.vue";
import { inject } from "vue";
import type { Card } from "@/interface/FormCC";
import type MultiChannelLink from "@/interface/MultiChannelLink";
import { boolean } from "yup";

const cards = ref<Card[]>([]);

const toggleSelected = (selectedCards: any) => {
  cards.value.forEach((card) => {
    if (card === selectedCards) {
      if (selectedCards.selected == true) {
        card.selected = false;
        prop.selectedCard.cardId = "";
      } else {
        card.selected = true;
        prop.selectedCard.cardId = card.cardId;
        prop.selectedCard.cardInfo = card.cardInfo;
        prop.selectedCard.cardName = card.cardName;
        prop.selectedCard.image = card.image;
        prop.selectedCard.minAge = card.minAge;
        prop.selectedCard.nationality = card.nationality;
        prop.selectedCard.selected = card.selected;
      }
    } else {
      card.selected = false;
    }
  });
};

const deviceType = inject("deviceType");

if (deviceType == "d") {
}
const { t } = i18n.global;

onBeforeMount(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

const eligibility = ref(true);
const prop = defineProps({
  selectedCard: {
    type: Object as PropType<Card>,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  nationality: {
    type: String,
  },
  grossSalary: {
    type: Number,
  },
  webFormRequestId: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  resumeId: {
    type: String,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  multiChannel: {
    type: Object as PropType<MultiChannelLink>,
    required: true,
  },
  creditLimit: {
    type: String,
  },
  productBundlingExpiredtype: {
    type: String,
    default: "",
  },
});

//List
const titleList = ref([]);
const relationshipList = ref([]);
const mobileCountryCodeList = ref([]);

onMounted(() => {
  emit("overlay");
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      relationshipList.value = res.data.relativeType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
    })
    .catch((e) => {});

  if (!prop.webFormRequestId && prop.type != "BIO") {
    const requestModel = {
      applicationChannel: prop.multiChannel.acc,
      nationality: "",
      type: prop.type,
    };
    // Initialize a Set to keep track of unique cardId values
    let addedCardIds = new Set();
    MasterService.cardValidate(requestModel)
      .then((res) => {
        for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
          // Check if the cardId is already in the Set
          if (!addedCardIds.has(res.data.responseModel.cardList[i].cardCode)) {
            cards.value.push({
              image: res.data.responseModel.cardList[i].cardImage,
              cardName: res.data.responseModel.cardList[i].cardDesc,
              cardInfo: res.data.responseModel.cardList[i].cardDesc2,
              cardId: res.data.responseModel.cardList[i].cardCode,
              selected: false,
              nationality: res.data.responseModel.cardList[i].nationality,
              minAge: res.data.responseModel.cardList[i].minAge,
              minSalary: res.data.responseModel.cardList[i].minSalary,
              defaultCard: res.data.responseModel.cardList[i].defaultCard,
            });
            // Add the cardId to the Set to mark it as added
            addedCardIds.add(res.data.responseModel.cardList[i].cardCode);
          }
        }
        emit("closeOverlay");

        // highlight
        if (prop.selectedCard.cardId != "") {
          cards.value.forEach((card) => {
            if (card.cardId == prop.selectedCard.cardId) card.selected = true;
          });
        }
      })
      .catch((e) => {});
  } else {
    const requestModel = {
      applicationChannel: prop.multiChannel.acc,
      nationality: prop.nationality,
      grossSalary: prop.grossSalary,
      type: prop.type,
    };

    MasterService.cardValidate(requestModel)
      .then((res) => {
        if (!res.data.responseModel.isEligible) {
          emit("jumpStep", 14, "cardApplicationNotQualify", 4);
        }
        for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
          cards.value.push({
            image: res.data.responseModel.cardList[i].cardImage,
            cardName: res.data.responseModel.cardList[i].cardDesc,
            cardInfo: res.data.responseModel.cardList[i].cardDesc2,
            cardId: res.data.responseModel.cardList[i].cardCode,
            selected: false,
            nationality: res.data.responseModel.cardList[i].nationality,
            minAge: res.data.responseModel.cardList[i].minAge,
            minSalary: res.data.responseModel.cardList[i].minSalary,
            defaultCard: res.data.responseModel.cardList[i].defaultCard,
          });
        }
        emit("closeOverlay");

        // highlight
        if (prop.selectedCard.cardId != "") {
          cards.value.forEach((card) => {
            if (card.cardId == prop.selectedCard.cardId) card.selected = true;
          });
        } else if (prop.cardId != "") {
          cards.value.forEach((card) => {
            if (card.cardId == prop.cardId) {
              prop.selectedCard.cardId = prop.cardId;
              card.selected = true;
            }
          });
        }
        // default card
        else if (res.data.responseModel.haveDefaultCard) {
          cards.value.forEach((card) => {
            if (card.defaultCard) {
              card.selected = true;
              prop.selectedCard.cardId = card.cardId;
            }
          });
        }
      })
      .catch((e) => {});
  }
});

const schema = computed(() => {
  return true;
});

const onInvalidSubmit = () => {};

const isBtnDisabled = computed(() => {
  return cards.value.findIndex((x) => x.selected) < 0;
});

const emit = defineEmits([
  "nextStep",
  "jumpStep",
  "submit",
  "setCardId",
  "closeModal",
  "setCardName",
  "overlay",
  "closeOverlay",
  "disabledPopout",
  "enabledPopout",
  "tokenSessionTimeOut",
  "emptyCardSubmit",
  "getProductStep",
]);

const handleBack = () => {
  emit("jumpStep", 1, "", 4);
};
const jump = () => {
  emit("setCardId");
  emit("setCardName");
  if (prop.selectedCard.cardId == "" || prop.selectedCard.cardId == "NA")
    return;
  if (prop.type == "MC") {
    // Get the current URL
    const currentUrl = window.location.href;

    // Create a URL object
    const url = new URL(currentUrl);

    // Update the CPC parameter
    url.searchParams.set("CPC", prop.selectedCard.cardId);

    // Use replaceState to change the URL without reloading the page
    window.history.replaceState({}, "", url.toString());

    if (prop.isAutoPopulate) {
      const cardSubmissionRequestModel = {
        webFormRequestId: prop.resumeId,
        cardId: prop.selectedCard.cardId,
      };
      MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
        .then((res) => {
          if (res.status == 200) {
            emit("jumpStep", 1, "", 4);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data.code == "WB-401") {
            // EndSession
            emit("tokenSessionTimeOut");
          }
        });
    } else {
      emit("jumpStep", 1, "", 4);
    }
  } else if (prop.type == "PF_CC" || prop.type == "EP_CC") {
    emit("disabledPopout");
    const cardSubmissionRequestModel = {
      webFormRequestId: prop.webFormRequestId,
      cardId: prop.selectedCard.cardId,
    };
    MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
      .then((res) => {
        if (res.status == 200) {
          //TODO-Matrix
          // go to additional information page
          emit("getProductStep", true, false, false, false, "");
          emit("enabledPopout");
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          emit("tokenSessionTimeOut");
        }
        emit("enabledPopout");
      });
  } else if (prop.pfExpired) {
    const cardSubmissionRequestModel = {
      webFormRequestId: prop.resumeId,
      cardId: prop.selectedCard.cardId,
    };
    MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
      .then((res) => {
        if (res.status == 200) {
          emit("jumpStep", 1, "", 4);
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          emit("tokenSessionTimeOut");
        }
      });
  } else if (
    prop.type == "BIO" ||
    prop.type == "CR_SL" ||
    prop.type == "FINPLUS"
  ) {
    const params = new URLSearchParams(window.location.search);
    if (params.has("cc")) {
      // Get the current URL
      const currentUrl = window.location.href;

      // Create a URL object
      const url = new URL(currentUrl);

      // Update the CPC parameter
      url.searchParams.set("cc", prop.selectedCard.cardId);

      // Use replaceState to change the URL without reloading the page
      window.history.replaceState({}, "", url.toString());
    }
    emit("submit");
  } else {
    window.history.replaceState(null, "", "?cc=" + prop.selectedCard.cardId);

    if (prop.isAutoPopulate) {
      const cardSubmissionRequestModel = {
        webFormRequestId: prop.resumeId,
        cardId: prop.selectedCard.cardId,
      };
      MasterService.cardSubmission(cardSubmissionRequestModel, prop.token)
        .then((res) => {
          if (res.status == 200) {
            emit("jumpStep", 1, "", 4);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data.code == "WB-401") {
            // EndSession
            emit("tokenSessionTimeOut");
          }
        });
    } else {
      emit("jumpStep", 1, "", 4);
    }
  }
};

const handleEnterKey = () => {};

const getFilteredInfo = (infos: any): string[] => {
  return Object.values(infos).filter(
    (info): info is string => typeof info === "string" && info.trim() !== "",
  );
};
</script>
<style scoped>
.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
  border-bottom: 1px solid #e4e4e4;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  width: 70%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.full {
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

.flex_third {
  width: 30%;
}

.container3 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
    margin-bottom: 10px;
  } */

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }
}

.container:is(.Mobile) {
  flex-direction: column;
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

/* .margin:is(.Mobile) {
  margin-bottom: 10px;
} */

.flex_third:is(.Mobile) {
  width: 30%;
}

.cardImage {
  max-width: 100%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  object-fit: contain;
  box-shadow: 0px 5px 20px 10px #00000029;
  border-radius: 8px;
}

.cardImgBox {
  width: 240px;
  height: 210px;
  display: flex;
  align-items: center;
  margin: 0 auto 10px auto;
}

.infoBox {
  width: 280px;
  margin: auto;
}

.merchant_code {
  text-align: right;
  color: #111;
  font: 450 24px / 130% Outfit;
}

.merchant_code:is(.Mobile) {
  font-size: 16px;
  padding-bottom: 15px;
}

@media only screen and (max-width: 700px) {
  .merchant_code {
    padding-right: 8%;
  }
}

.merchant_code:is(.Mobile) {
  text-align: unset;
  padding: 5px 20px;
}

.description {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 70px;
}

.description:is(.Mobile) {
  display: block;
}

.desc1 {
  flex: 1;
  min-width: 0;
}
</style>
